export default "__VITE_ASSET__6941f2bc__"